/* eslint-disable no-empty */
import { create } from 'zustand'
import { FormatAliasPhone, formatPhoneNumber } from '@shared/lib/phone'
import { reqHeaders } from '@shared/config/constants'
import { ewcatApi } from '@root/api/api'
import { AuthDataActions, InitialState } from './auth.types'

const initialState: InitialState = {
  isAuth: false,
  userData: null,
  profile: null,
  mtsData: null,
  isClient: false,
  isLoading: false,
  error: null,
  profileStatus: 'idle',
  operatorMTS: false,
  paymentBanMTS: false,
  errorOperatorInfo: null,
}

export const useAuthDataStore = create<AuthDataActions>((set, get) => ({
  ...initialState,
  setIsAuth: (isAuth: boolean) => set(() => ({ isAuth })),
  setUserData: (userData) =>
    set(() => ({
      userData,
      isClient: Boolean(userData?.rbo_id || userData?.wallet_id),
    })),
  setMtsData: (mtsData) => set(() => ({ mtsData })),
  getPhone: () => get().mtsData?.phone as string,
  fetchProfile: () => {
    if (get().isLoading) {
      return
    }

    set({ isLoading: true, error: null, profileStatus: 'idle' })

    // const fetchProfileData = async () => {
    //   const res = await ewalletProfileApi.getWallet()

    //   if (res?.data) {
    // TODO: закомментировал создание профиля
    // if (res?.data?.error?.code === 225) {
    //   const createProfile = await ewalletProfileApi.ewalletAuth()

    //   set({
    //     profile: { phone: createProfile?.data?.msisdn, userId: createProfile?.data?.userId },
    //   })
    // } else {
    //     set({
    //       profile: res.data,
    //       profileStatus: 'success',
    //     })
    //     // }

    //     if (res.data?.phone && res.data?.userId) {
    //       await fetchOperatorInfo(res.data.phone)
    //     }
    //   }
    // }

    const fetchOperatorInfo = async (phone: string) => {
      try {
        const response = await ewcatApi.getInfoMyMsisdnDo('b', phone, {
          headers: {
            ...reqHeaders,
          },
        })
        const { topUpServiceUniqueId, errorCode, operatorCode } = response.data

        if (topUpServiceUniqueId === 'TOP_UP_SERVICE_UNIQUE_ID_UNKNOWN') {
          set({ paymentBanMTS: true })
        }

        if (errorCode === 0 && operatorCode === 'mMTS') {
          set({ operatorMTS: true })
        }
      } catch (error) {
        set({ errorOperatorInfo: true })
      }
    }

    const fetcher = async () => {
      try {
        await fetchOperatorInfo(formatPhoneNumber(get().getPhone(), FormatAliasPhone.DIGIT11) as string)
      } catch (error) {
        set({ error, isLoading: false })
      }
    }

    fetcher()
  },
}))
